import { render, staticRenderFns } from "./AddAssetButton.vue?vue&type=template&id=7fbb6be3&scoped=true&"
import script from "./AddAssetButton.vue?vue&type=script&lang=js&"
export * from "./AddAssetButton.vue?vue&type=script&lang=js&"
import style0 from "./AddAssetButton.vue?vue&type=style&index=0&id=7fbb6be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbb6be3",
  null
  
)

export default component.exports